<template>
    <v-toolbar
      class="app-header"
      app
    >
      <v-spacer />
      <v-toolbar-title class="headline text-uppercase">
        <router-link to="/">
          <img
            class="logo"
            alt="logo"
            :src="require('../assets/logo.jpg')"
          >
        </router-link>
      </v-toolbar-title>
      <v-spacer />
    </v-toolbar>
</template>

<script>
export default {
    name: "AppHeader"
}
</script>

<style scoped>
.app-header {
  z-index: 150;
}
.app-header--dark {
  background-color: #212121;
  box-shadow: none !important;
}

.logo {
    display: block;
    width: auto;
    height: 56px;
  }
</style>

